import { unitOperationsConfig } from '../../../_config/unit-operations.config';
import { BaseWaterImportUnitOperation } from './base-water-import-unit-operation';

export class WaterSourceImport extends BaseWaterImportUnitOperation {
  category = unitOperationsConfig.waterSourceImport.key;
}
